var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "comment-badge"
  }, [_vm._m(0), _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "comment-body mb-2"
  }, [_c('div', {
    staticClass: "comment-body-header row m-0 mb-3 mb-lg-0 mb-lx-0"
  }, [_c('p', {
    staticClass: "col-12 col-lg-6 col-lx-6 p-0 text-start"
  }, [_vm._v(_vm._s(_vm.name))]), _c('p', {
    staticClass: "col-12 col-lg-6 col-lx-6 p-0 text-start text-lg-right text-xl-right"
  }, [_vm._v(_vm._s(_vm.relativeTime))])]), _c('p', {
    staticClass: "comment-body-text",
    domProps: {
      "innerHTML": _vm._s(_vm.body.replace(/\n/g, '<br>'))
    }
  })])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "comment-badge-image"
  }, [_c('i', {
    staticClass: "mdi mdi-account"
  })]);

}]

export { render, staticRenderFns }